import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, config = {}) => {
    const token = await getToken();
    const res = await axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` }, ...config });
    return res.data;
  }, [getToken]);
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return "Please check the form fields";
  return d || "Something went wrong";
}

export function useFileUrl(path) {
  const api = useApi();
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!path) { setUrl(null); return; }
    let objUrl; let off = false;
    api("get", `/files/${path}`, null, { responseType: "blob" })
      .then((b) => { if (off) return; objUrl = URL.createObjectURL(b); setUrl(objUrl); })
      .catch(() => {});
    return () => { off = true; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path, api]);
  return url;
}
